import { RouteRecordRaw } from "vue-router"
import { CompanyRouteNameEnum } from "@/shared/enums/routes/company.enum.ts"
import { AppPermissions } from "@/shared/permissions"

export const companiesRoutes: RouteRecordRaw[] = [
	{
		path: "/companies",
		name: CompanyRouteNameEnum.list,
		component: () => import("@/pages/companies/CompaniesListPage.vue"),
		meta: {
			title: CompanyRouteNameEnum.list,
			layout: "MainLayout",
			authRequired: true,
			permission: AppPermissions.CanViewSubordinateCompanies,
		},
	},
	{
		path: "/companies/create",
		name: CompanyRouteNameEnum.create,
		component: () => import("@/pages/companies/CompaniesCreatePage.vue"),
		meta: {
			title: CompanyRouteNameEnum.create,
			layout: "MainLayout",
			authRequired: true,
			permission: AppPermissions.CanCreateSubordinateCompany,
		},
	},
];
